import axios from 'axios'
import { BILLS_ENDPOINT } from '../../endpoints'

export async function updateBills(id, body) {
  const response = await axios.patch(`${BILLS_ENDPOINT}/${id}`, body)
  return response?.data?.data
}
